import * as THREE from "three";

export function initSnow(experience) {
  const { scene, textureLoader } = experience;

  // Textures
  const snowTexture = textureLoader.load("/textures/particles/snowflake.png");

  // Geometry
  const snowGeometry = new THREE.BufferGeometry();
  const snowCount = 10000;
  const snowPositions = new Float32Array(snowCount * 3);
  const snowSizes = new Float32Array(snowCount);

  for (let i = 0; i < snowCount; i++) {
    snowPositions[i * 3 + 0] = (Math.random() - 0.5) * 200;
    snowPositions[i * 3 + 1] = (Math.random() - 0.5) * 200;
    snowPositions[i * 3 + 2] = (Math.random() - 0.5) * 200;

    snowSizes[i] = Math.random();
  }

  snowGeometry.setAttribute(
    "position",
    new THREE.BufferAttribute(snowPositions, 3)
  );
  snowGeometry.setAttribute("size", new THREE.BufferAttribute(snowSizes, 1));

  // Material
  const snowMaterial = new THREE.PointsMaterial({
    size: 1,
    sizeAttenuation: true,
    // alphaMap: snowTexture,
    transparent: true,
    depthWrite: false,
    blending: THREE.AdditiveBlending,
  });

  // Points
  const snow = new THREE.Points(snowGeometry, snowMaterial);
  scene.add(snow);

  experience.animateSnow = (elapsedTime) => {
    snow.position.y = Math.sin(elapsedTime) * Math.sin(elapsedTime + 2) * 2;
    snow.rotation.y = elapsedTime * 0.2;
    snow.rotation.x = elapsedTime * 0.7;
  };
}
